import { S$ } from '@infl-ts/util-fp-ts';
import { noMemoRequest as hubRequest } from '@infl-ts/util-hub-axios-instance';
import { makeApiError, makeDecodeError } from '@infl-ts/util-make-apollo-decoded';
import { attachScheme } from '@infl-ts/util-url';
import { PermissionsResult } from '@infl-ts/util-use-admin-permissions';
import axios from 'axios';
import * as E from 'fp-ts/Either';
import { constant, pipe } from 'fp-ts/function';
import * as Id from 'fp-ts/Identity';
import * as O from 'fp-ts/Option';
import * as T from 'fp-ts/Task';
import * as TE from 'fp-ts/TaskEither';
import { SiteConfig } from './site-config-types';

var createAxios = function createAxios(_ref) {
  var jwt = _ref.jwt,
      host = _ref.host,
      cookie = _ref.cookie;
  return axios.create({
    baseURL: host ? attachScheme(host) : undefined,
    headers: jwt ? {
      Cookie: null,
      Authorization: "Bearer ".concat(jwt)
    } : {
      Cookie: cookie
    }
  });
};

var evolveConfigs = function evolveConfigs(siteConfig) {
  return pipe(siteConfig, S$.partialEvolve({
    configs: function configs(_ref2) {
      var AnalyticsConfig = _ref2.AnalyticsConfig,
          AppConfig = _ref2.AppConfig,
          ConsentConfig = _ref2.ConsentConfig,
          OnboardingConfig = _ref2.OnboardingConfig,
          PopoverConfig = _ref2.PopoverConfig,
          ThemeConfig = _ref2.ThemeConfig,
          MultilingualConfig = _ref2.MultilingualConfig;
      return {
        analyticsConfig: O.fromNullable(AnalyticsConfig),
        appConfig: O.fromNullable(AppConfig),
        consentConfig: O.fromNullable(ConsentConfig),
        onboardingConfig: O.fromNullable(OnboardingConfig),
        popoverConfig: O.fromNullable(PopoverConfig),
        themeConfig: O.fromNullable(ThemeConfig),
        multilingualConfig: O.fromNullable(MultilingualConfig)
      };
    }
  }), Id.bind('hubName', function (_ref3) {
    var appConfig = _ref3.configs.appConfig;
    return pipe(appConfig, O.chainNullableK(function (appConfig) {
      return appConfig.programName;
    }), O.getOrElse(constant('')));
  }));
};

export var getSiteConfig = function getSiteConfig(_ref4) {
  var host = _ref4.host,
      cookie = _ref4.cookie,
      jwt = _ref4.jwt;
  return pipe(TE.rightIO(function () {
    return createAxios({
      jwt: jwt,
      host: host,
      cookie: cookie
    });
  }), TE.chain(function (axiosInstance) {
    return TE.tryCatch(function () {
      return axiosInstance.get('/siteconfig_v2');
    }, makeApiError);
  }), TE.chainEitherKW(function (_ref5) {
    var data = _ref5.data;
    return pipe(SiteConfig.decode(data), E.mapLeft(makeDecodeError));
  }), TE.map(evolveConfigs));
};
export var getAdminConfig = function getAdminConfig(_ref6) {
  var host = _ref6.host,
      cookie = _ref6.cookie,
      jwt = _ref6.jwt;
  return pipe(hubRequest({
    config: {
      method: 'get',
      url: '/permissions',
      withCredentials: true,
      headers: jwt ? {
        Cookie: null,
        Authorization: "Bearer ".concat(jwt)
      } : {
        Cookie: cookie
      }
    },
    currentHubURL: host ? attachScheme(host) : undefined,
    cookie: cookie,
    jwt: jwt
  }), TE.chainEitherKW(function (_ref7) {
    var data = _ref7.data;
    return pipe(PermissionsResult.decode(data), E.mapLeft(makeDecodeError));
  }), TE.map(function (result) {
    return result.data;
  }), T.map(O.fromEither));
};